<template>
  <span class="scaling-svg-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" class="scaling-svg">
      <path
        d="M2.345,13.656A8,8,0,1,1,13.656,2.345,8,8,0,1,1,2.345,13.656ZM1.316,8A6.684,6.684,0,1,0,8,1.316,6.692,6.692,0,0,0,1.316,8Zm6.027,4.338V11.9A2.325,2.325,0,0,1,5.674,9.669a.657.657,0,0,1,1.314,0,1.013,1.013,0,0,0,1.752.689A.929.929,0,0,0,8.4,8.875L7.1,8.339A2.246,2.246,0,0,1,7.343,4.1V3.662a.657.657,0,0,1,1.314,0V4.1a2.33,2.33,0,0,1,1.669,2.23.657.657,0,1,1-1.314,0,1.014,1.014,0,0,0-1.727-.715A.929.929,0,0,0,7.6,7.124l1.3.536a2.244,2.244,0,0,1,.736,3.66,2.3,2.3,0,0,1-.978.576v.441a.657.657,0,0,1-1.314,0Z"
        transform="translate(0 0)"
      />
    </svg>
  </span>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class DollarInCircleIcon extends Vue {}
</script>

<style></style>
